import useMode from './useMode';
import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';

const useLocalStorageSettings = <T>(
  page: string,
  type: string
): [T | null, Dispatch<SetStateAction<T | null>>] => {
  const mode = useMode();
  const localStorageKey = `${mode}.${page}.${type}`;

  const localStorageValue = useMemo<T | null>(() => {
    const raw = localStorage.getItem(localStorageKey);
    if (raw === null || raw.toLowerCase() === 'null' || raw === 'undefined') {
      return null;
    }
    return JSON.parse(localStorage.getItem(localStorageKey) as string);
  }, [localStorageKey]);

  const [value, setValue] = useState(localStorageValue);

  useEffect(() => {
    if (value === null || value === undefined) {
      localStorage.removeItem(localStorageKey);
    } else {
      localStorage.setItem(localStorageKey, JSON.stringify(value));
    }
  }, [localStorageKey, value]);

  return [value, setValue];
};

export default useLocalStorageSettings;
